module.exports = window["MaterialUI"].Menu;